import '@fontsource-variable/dm-sans';
import '@fontsource/dm-mono/400.css';
import '@fontsource/dm-mono/500.css';
import './styles/globals.css';

import { I18nProvider } from '@lingui/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/app';
import { BootErrorScreen, bootRuntime } from './app/auth';
import { clearSessionCache, createQueryClient } from './app/query-client';
import { useShell } from './app/shell/shell-store';
import { activateLocale, i18n, initialLocale } from './shared/i18n/i18n';
import { toast } from './shared/ui/toaster';

const root = document.getElementById('root');
if (!root) throw new Error('#root ausente no index.html');

await activateLocale(initialLocale());
const queryClient = createQueryClient();
const reactRoot = createRoot(root);

try {
  const { config, session } = await bootRuntime({
    getCurrentTenant: () => useShell.getState().tenantId,
    subscribeCurrentTenant: (onChange) => useShell.subscribe((state, previous) => {
      if (state.tenantId !== previous.tenantId) onChange();
    }),
    onSignedOut: () => {
      clearSessionCache(queryClient);
      toast.dismiss();
    },
  });
  reactRoot.render(
    <StrictMode>
      <App queryClient={queryClient} config={config} session={session} />
    </StrictMode>,
  );
} catch (error) {
  reactRoot.render(
    <StrictMode>
      <I18nProvider i18n={i18n}>
        <BootErrorScreen error={error} />
      </I18nProvider>
    </StrictMode>,
  );
}
